import { proxyCustomElement, HTMLElement, createEvent, h } from '@stencil/core/internal/client';
import './index2.js';
import { D as DomService } from './index3.js';
import { r as remCalc } from './index5.js';
import { d as defineCustomElement$1 } from './roche-icon2.js';

var MessageType;
(function (MessageType) {
    MessageType["INFO"] = "info";
    MessageType["SUCCESS"] = "success";
    MessageType["FAIL"] = "fail";
    MessageType["INLINE_FAIL"] = "inline--fail";
})(MessageType || (MessageType = {}));
const messageTypeKeys = Object.keys(MessageType);
const messageTypeValues = messageTypeKeys.map((type) => MessageType[type]);

const rocheMessageCss = ":host .inline--fail,:host .success,:host .fail,:host .info{font-family:\"roche-sans\";font-style:normal;font-weight:200;color:var(--color-text--primary);font-size:var(--body--font-size--small-up);line-height:1.8125rem;display:flex;align-items:center;width:100%;padding:1rem 0}@media (min-width: 64rem){:host .inline--fail,:host .success,:host .fail,:host .info{font-size:var(--body--font-size--xlarge-up);line-height:2rem}}:host{display:block;margin-top:3rem;margin-top:0;overflow:hidden}@media (min-width: 90rem){:host{margin-top:4.5rem}}:host,:host *{box-sizing:border-box}@media (min-width: 64rem){:host{margin-top:0}}:host .text{width:100%;margin:0 0.5rem}:host .info{border-left:3px solid #06c;color:#06c;background-color:#cce0f5;transition:all 0.5s ease-in-out}:host .info.closed{opacity:0;margin-top:-3.3rem}:host .info .icon{margin-left:0.5rem;border-radius:50%;padding:0.25rem;background-color:#06c;fill:#fff}:host .info .close{cursor:pointer;margin-right:1rem;fill:#666}:host .fail{border-left:3px solid #c03;color:#c03;background-color:#f5ccd6;transition:all 0.5s ease-in-out}:host .fail.closed{opacity:0;margin-top:-3.3rem}:host .fail .icon{margin-left:0.5rem;border-radius:50%;padding:0.25rem;background-color:#c03;fill:#fff}:host .fail .close{cursor:pointer;margin-right:1rem;fill:#666}:host .success{border-left:3px solid #096;color:#096;background-color:#ccebe0;transition:all 0.5s ease-in-out}:host .success.closed{opacity:0;margin-top:-3.3rem}:host .success .icon{margin-left:0.5rem;border-radius:50%;padding:0.25rem;background-color:#096;fill:#fff}:host .success .close{cursor:pointer;margin-right:1rem;fill:#666}:host .inline--fail{color:var(--color-status--error);background-color:transparent;transition:all 0.5s ease-in-out;width:100%}@media (min-width: 48rem){:host .inline--fail{max-width:18.75rem}}:host([dir=rtl]) .info{border-right:3px solid #06c;border-left:0}:host([dir=rtl]) .info .icon{margin-right:0.5rem}:host([dir=rtl]) .info .close{margin-left:1rem}:host([dir=rtl]) .fail{border-right:3px solid #c03;border-left:0}:host([dir=rtl]) .fail .icon{margin-right:0.5rem}:host([dir=rtl]) .fail .close{margin-left:1rem}:host([dir=rtl]) .success{border-right:3px solid #096;border-left:0}:host([dir=rtl]) .success .icon{margin-right:0.5rem}:host([dir=rtl]) .success .close{margin-left:1rem}";
const RocheMessageStyle0 = rocheMessageCss;

const RocheMessage = /*@__PURE__*/ proxyCustomElement(class RocheMessage extends HTMLElement {
    get typeParsed() {
        return messageTypeValues.filter((type) => type === this.type)[0] || MessageType.INFO;
    }
    get icon() {
        switch (this.typeParsed) {
            case MessageType.SUCCESS:
                return 'mobile';
            case MessageType.FAIL:
                return 'mobile';
            default:
                return 'mobile';
        }
    }
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.closeEvent = createEvent(this, "rocheMessageClose", 7);
        this.text = undefined;
        this.type = MessageType.INFO;
        this.closed = false;
        this.handleClick = this.handleClick.bind(this);
    }
    componentDidLoad() {
        DomService.handleTextDirection(this.element);
    }
    render() {
        return (h("div", { key: 'cc84af601e30ee77590b2ee8b871ecf0967dd4d6', class: { closed: this.closed, [this.typeParsed]: true } }, this.type !== MessageType.INLINE_FAIL
            && h("roche-icon", { icon: this.icon, class: "icon", height: `${remCalc(12)}rem` }), h("div", { key: '1e1eb6feef293ef812f66d5752a6ec7b19a02daf', class: "text" }, this.text), this.type !== MessageType.INLINE_FAIL
            && h("roche-icon", { icon: "close", class: "close", height: `${remCalc(16)}rem`, onClick: this.handleClick })));
    }
    handleClick() {
        this.closed = true;
        this.closeEvent.emit(this);
    }
    get element() { return this; }
    static get style() { return RocheMessageStyle0; }
}, [1, "roche-message", {
        "text": [1],
        "type": [1],
        "closed": [1028]
    }]);
function defineCustomElement() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["roche-message", "roche-icon"];
    components.forEach(tagName => { switch (tagName) {
        case "roche-message":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, RocheMessage);
            }
            break;
        case "roche-icon":
            if (!customElements.get(tagName)) {
                defineCustomElement$1();
            }
            break;
    } });
}

export { MessageType as M, RocheMessage as R, defineCustomElement as d };

//# sourceMappingURL=roche-message2.js.map